var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrowserLock = function SvgBrowserLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 10.5v-2a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3.5a.5.5 0 0 1-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M5.5 8V7A1.5 1.5 0 0 1 7 5.5v0A1.5 1.5 0 0 1 8.5 7v1M.5 3.494h13"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1"
  }))));
};
export default SvgBrowserLock;